export const ADD_TO_CART = "ADD_TO_CART"
export const ADD_TO_HEART = "ADD_TO_HEART"